var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn', _vm.$style.button],on:{"click":_vm.toggleMute}},[_vm._v(_vm._s(_vm.buttonLabel))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-655a2562","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-coach-call/toolbar/mute-toggle-button/mute-toggle-button.vue
// module id = yT/X
// module chunks = 1